import { useSelector } from "react-redux";
import { LeaguePreview } from "../LeaguePreview";
import useCloudinaryData from "../../Common/hooks/useCloudinaryData";
import { getLeagueTypeBackgroundPath } from "../../Common/utils/cloudinary";

const LeaguePreviewWrapper = () => {
  const { cloudinaryBase, envVersion, currentSeasonYear, configData } =
    useCloudinaryData();

  const createLeagueData = useSelector(
    (state) => state.league.createLeagueData
  );

  const leagueTypeBackgroundImage = getLeagueTypeBackgroundPath(
    configData,
    cloudinaryBase,
    envVersion,
    currentSeasonYear,
    createLeagueData?.leagueType
  );

  return (
    <LeaguePreview
      leagueType={createLeagueData?.leagueType}
      leagueName={createLeagueData?.leagueName}
      leagueTypeBackgroundImage={leagueTypeBackgroundImage}
    />
  );
};

export { LeaguePreviewWrapper };
